import Breadcrumb from './Breadcrumb';
import Chip from '../../fragments/chip/Chip';
import ComponentWrapper from '../../fragments/component-wrapper/ComponentWrapper';

import { motion } from 'motion/react';
import { AnimateSplitText } from '../../fragments/split-text/AnimateSplitText';

export default function PageHeader({ block, index, pageData }) {
  if (!block) return null;

  const HeadingTag = index === 0 ? 'h1' : 'h2';
  const SubheadingTag = index === 0 ? 'h2' : 'h3';

  const defaultEase = [0, 0.65, 0.45, 1];

  const duration = 0.5;

  const charVariants = {
    animate: (i) => ({
      clipPath: 'inset(0% 0 -30%)',
      y: 0,
      transition: {
        delay: 0.5 + i * 0.05,
        duration: duration,
        ease: defaultEase,
      },
    }),
  };

  return (
    <ComponentWrapper className="PageHeader">
      <div className="l-grid">
        <div className="l-grid__col l-grid__col--l-9-12">
          {pageData?.parents && <Breadcrumb parents={pageData.parents} />}
          {block.heading && (
            <HeadingTag className="h1">
              {' '}
              <AnimateSplitText
                variants={charVariants}
                initial={{
                  clipPath: 'inset(0 0 100%)',
                  y: '110px',
                }}
                animate="animate"
              >
                {block.heading}
              </AnimateSplitText>
            </HeadingTag>
          )}
          {block.subheading && (
            <SubheadingTag className="h7">
              <motion.span
                style={{ display: 'block' }}
                initial={{ opacity: 0, y: '10px' }}
                animate={{ opacity: 1, y: '0px' }}
                transition={{ type: 'spring', duration: 0.7, delay: 0.7 }}
              >
                {block.subheading}
              </motion.span>
            </SubheadingTag>
          )}
          {block.description && (
            <motion.p
              className="text--size-l text--condensed"
              initial={{ opacity: 0, y: '10px' }}
              animate={{ opacity: 1, y: '0px' }}
              transition={{ type: 'spring', duration: 0.7, delay: 0.7 }}
            >
              {block.description}
            </motion.p>
          )}
          {block.tags && (
            <motion.div
              className="PageHeader-chips"
              initial={{ opacity: 0, y: '10px' }}
              animate={{ opacity: 1, y: '0px' }}
              transition={{ type: 'spring', duration: 0.7, delay: 0.8 }}
            >
              {block.tags.map((tag, i) => (
                <Chip label={tag.name} key={i} />
              ))}
            </motion.div>
          )}
        </div>
      </div>
    </ComponentWrapper>
  );
}
